import { useMutation } from '@tanstack/react-query'
import { GuestActivityDto } from '@chilipiper/api-client/src/chili-crm'
import { useApiClient } from '@chilipiper/api-client/src/context'

export const useSubmitGuestActivity = (tenantId: string, guestId: string) => {
  const { chiliCrm } = useApiClient()

  return useMutation({
    mutationFn: (event: GuestActivityDto) => {
      return chiliCrm.submitGuestActivity(tenantId, guestId, event, { keepalive: true })
    },
  })
}

export const useSubmitGuestActivitySync = (tenantId: string, guestId: string) => {
  const { chiliCrm } = useApiClient()

  return useMutation({
    mutationFn: (event: GuestActivityDto) => {
      return chiliCrm.submitGuestActivitySync(tenantId, guestId, event, { keepalive: true })
    },
  })
}
